import React, { useEffect, useState } from "react";
import { formatMobile, formatPhone, formatName } from "../../../lib/Misc";
import Spin from "../../../components/Spin";
import { ResponsiveDrawerForm } from "../../../components/ResponsiveDrawerForm";
import { CardTitle } from "../../../components/ui/card";
import DetailPhotoBody from "../../../components/DetailPhotoBody";
import { getUserDetail } from "../TransactionHelper";

const UserDetailPopup = ({ id, showView, setShowView }) => {
  const [userDetail, setUserDetail] = useState(null);
  const [userLoading, setUserLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      const userDetailData = await getUserDetail(id);
      setUserDetail(userDetailData);
      setUserLoading(false);
    }
    fetchData();
  }, [id]);

  return (
    <ResponsiveDrawerForm
      description={""}
      title={"User Details"}
      handleOpen={() => {}}
      handleClose={() => {}}
      className={"md:w-[65vw]"}
      open={showView}
      buttonClassName={""}
      setOpen={setShowView}
      popupType={"users"}
      read={true}
    >
      {userLoading ? (
        <Spin full expand={true} />
      ) : (
        <div className="md:p-0 p-4">
          <DetailPhotoBody
            textValue={userDetail?.first_name?.charAt(0)}
            imgURL={userDetail?.profile_pic}
            profileName={formatName(
              userDetail?.first_name,
              userDetail?.last_name
            )}
          />
          <div className="modal-content">
            <CardTitle className="text-md mb-2">Personal Details</CardTitle>
            <div className="modal-content-details grid grid-cols-1 md:grid-cols-2 gap-3">
              <p>
                <strong>First Name:</strong>{" "}
                {userDetail?.first_name ? userDetail?.first_name : "-"}
              </p>
              <p>
                <strong>Last Name:</strong> {userDetail?.last_name}
              </p>
              <p>
                <strong>Email Address:</strong> {userDetail?.email}
              </p>
              <p>
                <strong>Phone Number:</strong>{" "}
                {userDetail?.phone ? formatPhone(userDetail?.phone) : ""}
              </p>
              <p>
                <strong>Mobile Number:</strong>{" "}
                {userDetail?.mobile ? formatMobile(userDetail?.mobile) : "-"}
              </p>
            </div>
          </div>
        </div>
      )}
    </ResponsiveDrawerForm>
  );
};

export default UserDetailPopup;
